'use client';

import { Checkbox } from '@lichtblick/photon/molecules/checkbox';
import { type PropsWithChildren, useState } from 'react';

type GasCheckboxProps = PropsWithChildren & {
  defaultChecked?: boolean;
};

export const GasCheckbox: React.FC<GasCheckboxProps> = ({ children, defaultChecked }) => {
  const [isChecked, setIsChecked] = useState(defaultChecked || false);

  return (
    <>
      <Checkbox label={<Checkbox.Label>Gas hinzufügen</Checkbox.Label>}>
        <Checkbox.Checkbox
          data-testid="checkbox-gas"
          defaultChecked={isChecked}
          name="combo-gas"
          onChange={(e) => {
            setIsChecked(e.target.checked);
          }}
        />
      </Checkbox>

      {isChecked && children}
    </>
  );
};
